import React, { FC, useCallback, useEffect, useRef } from 'react';
import './CreateTemplate.scss';
import Upload from '../../../../Components/Upload/Upload';
import { useNavigate } from 'react-router-dom';
import { EPath, Paths } from '../../../../Core/EPath';
import { useTranslation } from 'react-i18next';
import fly from "../../../../Assets/icons/owl.png";
import { ReactSVG } from 'react-svg';
import infoIcon from '../../../../Assets/icons/info-circle.svg'
import Tooltip, { ETooltipPosition } from '../../../../Components/Tooltip/TooltipOnRef';
import RestrictReadOnly from '../../../../Helpers/RestrictReadOnly';

interface UploadTemplateProps {
    template?: any;
}

export const UploadTemplate: FC<UploadTemplateProps> = ({ template }) => {
    const tooltipTargetRef = useRef<HTMLDivElement>(null);

    const { t } = useTranslation();
    const navigate = useNavigate();

    const createTemplate = useCallback((id: string) => {
        navigate(Paths.TEMPLATE_DETAIL({ id }))
    }, [navigate]);

    const LoadingTemplate = () => {

        return (
            <>
                <div className="template-name">
                    {template?.name}
                </div>
                <div className={"template-status analyzing"}>
                    <h3>{t('draft.analyzing')}</h3>
                    <div className="loader"></div>
                </div>
            </>
        )
    }

    return (
        <div className="upload-template">

            <div className="boxes">
                <img src={fly} alt="Fly" />
                <h3>{t('template.create')}</h3>
                <div className={"box"}>
                    <div className="title" >
                        {t('draft.precedent')}
                        <div ref={tooltipTargetRef}>
                            <ReactSVG className='info-icon' src={infoIcon} />
                        </div>
                        <Tooltip targetRef={tooltipTargetRef} position={ETooltipPosition.RIGHT}>
                            <div>{t('drafting.createTemplateTooltip')}</div>
                        </Tooltip>
                    </div>
                    <div className="box-content">
                    {template ? 
                        <LoadingTemplate /> : 
                        <RestrictReadOnly><Upload update={createTemplate} type={"draft-template"} /></RestrictReadOnly>
                    }
                    </div>
                </div>
            </div>

        </div>
    )
};

const CreateTemplate = () => {

    const navigate = useNavigate();

    useEffect(() => {
        navigate(EPath.TEMPLATE);
    }, [navigate]);

    return (
        <UploadTemplate />
    )
}

export default CreateTemplate;